module.exports = "https://static.wmbcdn.com/uniweb/images/21b13e60a4316f8b23ac2da7b4a74ad1.svg";